import React from "react";
import l from "components/util/l";

const getAnnotationIconClass = (annotationType) => {
  if (annotationType === "mockup")
    return "fa-image";
  if (annotationType === "tab")
    return "fa-align-left";
  return "fa-comment-dots";
}

const getVisibilityScopeLabel = (visibilityScope) => {
  if (visibilityScope === "DEV")
    return l("Desarrollo%PA481");
  return l("Cliente%PA479");
}

const RevisionAnnotationComments = ({
  sectionAnnotations,
  showCommentsPanel,
  editingCommentId,
  draftText,
  allowComments,
  isDeveloper,
  showAdditionalCommentButton = false,
  onClickStartEditingComment,
  onClickSaveEditingComment,
  onClickCancelEditingComment,
  onClickAddAdditionalComment,
  onClickRemoveComment,
  onChangeDraftText,
  onChangeResolvedState,
}) => {

  if (!showCommentsPanel)
    return null;

  return (
    <div
      className="revision-annotations h-100 flex-shrink-0 overflow-hidden"
      style={{ borderRadius: "0.5rem", border: "1px solid #ffffff30" }}>

      <div className="d-flex flex-column overflow-hidden h-100 rounded" style={{ backgroundColor: "#00000020" }}>
        <div className="d-flex justify-content-between align-items-center px-2 py-3">
          <div className="d-flex align-items-center">
            <div
              className="rounded-circle p-2 mr-1 d-flex align-items-center justify-content-center"
              style={{ background: "#ffffff20" }}
            >
              <i className="fas fa-comments text-white"></i>
            </div>

            <div>
              <h5 className="m-0 font-weight-bold text-white">
                {l("Comentarios%PA365")}
              </h5>
            </div>
          </div>

        </div>

        <div className="flex-fill overflow-auto px-1"
          style={{ scrollbarColor: "#ffffff40 #00000012" }}>
          {allowComments &&
            <div className="text-center d-flex flex-column justify-content-center align-items-center">
              <div className="py-1 text-center">
                <div className="text-white-70" style={{ fontSize: "0.84rem", lineHeight: "1.4" }}>
                  {l("Selecciona el texto o la pantalla para agregar comentarios%PA503")}
                </div>
              </div>
            </div>
          }

          <div className="comment-list">
            {sectionAnnotations.map((annotation) => {
              const visibilityScope = annotation?.visibility_scope || "CLIENT";
              const isResolved = !!annotation?.is_solved;

              return (
                <div
                  key={annotation.id}
                  className="mt-3 rounded-xl transition-all p-3 cursor-default border-light-2"
                  style={{
                    backgroundColor: isResolved ? "#e0e0e0" : "#ffffff",
                    borderRadius: "0.5rem",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div className="d-flex align-items-start mb-1">
                    <div className="d-flex align-items-center mr-2 mb-1">
                      <span
                        className="badge border-0 px-2"
                        style={{
                          borderRadius: "0.375rem",
                          fontSize: "12px",
                          backgroundColor: "#fff3d6",
                          color: "#8a6200",
                        }}
                      >
                        <i className={`fas ${getAnnotationIconClass(annotation.type)} mr-1`}></i>
                        {annotation.annotationNumber}
                      </span>

                      {isDeveloper &&
                        <span
                          className="badge border-0 px-2 ml-1"
                          style={{
                            borderRadius: "6px",
                            fontSize: "10px",
                            backgroundColor: visibilityScope === "DEV" ? "#d6ecff" : "#d9f7e8",
                            color: visibilityScope === "DEV" ? "#005792" : "#17663a",
                          }}
                        >
                          {getVisibilityScopeLabel(visibilityScope)}
                        </span>
                      }
                    </div>

                    <div className="flex-fill"></div>

                    <button
                      type="button"
                      className={"btn btn-xs mr-2 p-0"}
                      disabled={!allowComments}
                      onClick={() => onChangeResolvedState(annotation, !isResolved)}
                    >
                      <i className={"fas mr-1 " + (isResolved ? "fa-check-circle text-success" : "fa-check text-primary")}></i>
                    </button>

                    {allowComments &&
                      <button
                        type="button"
                        className="btn btn-link btn-xs text-danger p-0 opacity-25 hover-opacity-100 transition-opacity"
                        onClick={() => onClickRemoveComment(annotation)}
                        title={l("Eliminar comentario%PA540")}
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    }
                  </div>

                  <div className="comment-body">
                    {isDeveloper &&
                      <div className="px-1 mb-1 small font-weight-bold" style={{ color: "#a0a0a0" }}>
                        {annotation.author || l("Usuario Anónimo%PA349")}
                      </div>
                    }

                    {!allowComments &&
                      <p
                        className="mb-1 px-1 font-weight-medium text-dark"
                        style={{
                          fontSize: "0.85rem",
                          lineHeight: "1.5",
                          whiteSpace: "pre-wrap",
                          textDecoration: isResolved ? "line-through" : "none",
                        }}
                      >
                        {annotation.text}
                      </p>
                    }

                    {allowComments && editingCommentId !== annotation.id &&
                      <div
                        type="button"
                        className="w-100 text-left text-dark border-0 p-2"
                        style={{
                          fontSize: "0.9rem",
                          lineHeight: "1.4",
                          whiteSpace: "pre-wrap",
                          textDecoration: isResolved ? "line-through" : "none",
                        }}
                        onClick={() => onClickStartEditingComment(annotation)}
                      >
                        {annotation.text || l("Escribe un comentario...%PA541")}
                      </div>
                    }

                    {allowComments && editingCommentId === annotation.id &&
                      <>
                        <textarea
                          className="form-control form-control-sm border-0 bg-light p-2"
                          style={{
                            fontSize: "0.9rem",
                            resize: "none",
                            lineHeight: "1.4",
                            background: "#f0f2f4",
                            borderRadius: "0.35rem",
                          }}
                          value={draftText}
                          rows={3}
                          autoFocus
                          placeholder={l("Escribe un comentario...%PA541")}
                          onChange={onChangeDraftText}
                        />

                        <div className="d-flex justify-content-end mt-2">
                          <button type="button" className="btn btn-link btn-sm mr-2" onClick={onClickCancelEditingComment}>
                            {l("Cancelar%GA021")}
                          </button>

                          <button type="button" className="btn btn-primary btn-sm" onClick={() => onClickSaveEditingComment(annotation)}>
                            {l("Guardar%GA023")}
                          </button>
                        </div>
                      </>
                    }


                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {showAdditionalCommentButton && allowComments &&
          <div className="px-2 py-3 flex-shrink-0" style={{ borderTop: "1px solid #ffffff70" }}>
            <button type="button" className="btn btn-sm btn-outline-primary-white btn-block" onClick={onClickAddAdditionalComment}>
              <i className="fas fa-plus mr-2"></i>
              {l("Comentario adicional%PA504")}
            </button>
          </div>
        }
      </div>

    </div>
  );
};

export default RevisionAnnotationComments;
